export { default as ShieldCheckOutlineIcon } from './ShieldCheckOutlineIcon';
